import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
const drawerWidth = 270

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      '& .MuiDrawer-paper': {
        position: 'unset',
        borderRadius: '0.75rem 0 0 0.75rem',
        background: '#fff',
        border: '1px solid hsl(240 5.9% 90%)',
        color: '#000',
      },
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: 36,
    },
    hide: {
      display: 'none',
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: 'nowrap',
    },
    drawerOpen: {
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      top: 'auto',
      zIndex: 'auto',
    },
    drawerClose: {
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      overflowX: 'hidden',
      width: theme.spacing(7) + 1,
      top: 'auto',
      zIndex: 'auto',
    },
    toolbar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '4px',
      ...theme.mixins.toolbar,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },

    sidebarList: {
      height: '100%',
    },
    sidebarListItem: {
      '& .MuiListItemText-root, & .MuiListItemIcon-root svg, & .MuiListItemIcon-root svg path':
        {
          color: '#000',
          fill: '#000',
        },

      '&.MuiButtonBase-root:hover': {
        background: 'hsl(210 40% 96.1%)',
        '& .MuiListItemText-root, & .MuiListItemIcon-root svg, & .MuiListItemIcon-root svg path':
          {
            color: theme.palette.secondary.main,
            fill: theme.palette.secondary.main,
          },
      },
    },
  }),
)
